import {Fancybox} from '@fancyapps/ui'

global.Fancybox = window.Fancybox = Fancybox

Fancybox.resize = function(options) {
    //let iframeH = Fancybox.getSlide().iframeEl.contentWindow.innerHeight
    //console.log("resizeFancybox")

    if(!Fancybox.getSlide()){
        return
    }
    let iframeH = (Fancybox.getSlide().iframeEl.contentDocument) ? Fancybox.getSlide().iframeEl.contentDocument.documentElement.scrollHeight : null;
    let $fancyboxContent = $(Fancybox.getSlide().el).find('.fancybox__content')
    let s = window.getComputedStyle($fancyboxContent[0])
    let paddingTop = 0;//parseInt(s.getPropertyValue('padding-top'))
    let paddingBottom = 0;//parseInt(s.getPropertyValue('padding-bottom'))

    //console.log(paddingTop + iframeH + paddingBottom);

    if(!iframeH) {
        iframeH = window.innerHeight * 0.7;
    }

    if(iframeH) {
        iframeH = paddingTop + iframeH + paddingBottom;
        if(iframeH > (window.innerHeight * 0.9)) {
            iframeH = window.innerHeight * 0.9;
        }
        $fancyboxContent.height(paddingTop + iframeH + paddingBottom)
    }
}

let resizeCallBback = {
    reveal: (fancybox, eventName) => {
        resizeIntervalId = setInterval(function (){
            Fancybox.resize()
        }, 300)
    },
    destroy: (fancybox, eventName) => {
        clearInterval(resizeIntervalId)
    },
}

Fancybox.bind("[data-fancybox]", {
    backdropClick: false,
    dragToClose: false,
    on: resizeCallBback,
});
Fancybox.bind("[data-fancybox-narrow]", {
    on: resizeCallBback,
    backdropClick: false,
    dragToClose: false,
    mainClass: "fancybox--narrow"
});
Fancybox.bind("[data-fancybox-wide]", {
    on: resizeCallBback,
    backdropClick: false,
    dragToClose: false,
    mainClass: "fancybox--wide"
});


$('body').on('click', '[data-dismiss="fancybox"]', function(e) {
    parent.Fancybox.close();
})

var resizeIntervalId = null
window.openModal = function (src, type, slideOps, ops, events){
    console.info(`openModal:${type}: ` + src)
    var openOpts = {
        backdropClick: false,
        dragToClose: false,
        on: {
            reveal: (fancybox, eventName) => {
                resizeIntervalId = setInterval(function (){
                    Fancybox.resize()
                }, 300)
            },
            destroy: (fancybox, eventName) => {
                clearInterval(resizeIntervalId)
            },
        }
    };
    var slide = null;
    switch (type){
        case 'iframe':
            slide = {
                src  : src,
                type : 'iframe',
            }
            break;
        case 'ajax':
            slide = {
                src  : src,
                type : 'ajax',
            }
            break;
        default:
            slide = {
                src  : src,
                type : type,
                smallBtn : true,
                toolbar  : false,
                baseClass: 'fancybox-iframe-edit',
                opts : {}
            }
            break;
    }
    if(slide){
        if(slideOps){
            slide = $.extend(slide, slideOps);
        }
        if(ops){
            openOpts = $.extend(openOpts, ops);
        }
        if(events){
            openOpts.on = $.extend(openOpts.on || {}, events);
        }
        parent.Fancybox.show([ slide ], openOpts)
    }
}
